import {Moment} from "moment";
import {Bar, BarChain, GeoLocation} from "./Bar";
import moment from "moment/moment";

/**
 * IDeal instance with start and end times as Moment objects and weekday as a localized string.
 */
export interface IMomentDeal {
    description: string,
    conditions: string,
    times: Moment[],
    day: string,
    owner: DealParentWithLocations,
    afterMidnight: AfterMidnight,
    today: boolean,
    tomorrow: boolean
}

export interface NearbyDeal extends IMomentDeal {
    distance: number,
    bar: Bar
}

export interface DealParent {
    name: string,
    description: string|null,
    updated_at: number
}

export interface DealParentWithLocations extends DealParent{
    locations: GeoLocation[]
}

export function isBar(object: DealParent): object is Bar {
    return 'address' in object;
}

export function isChain(object: DealParent): object is BarChain {
    return !('address' in object);
}

export function getDealOwnerLink(owner: DealParent): string {
    return isBar(owner) ? owner.id : (isChain(owner) ? "c/" + owner.id : "")
}

export function getContributeLink(dealOwner: DealParent): string | undefined {
    function isBar(object: any): object is Bar {
        return 'address' in object;
    }

    function isChain(object: any): object is BarChain {
        return !('address' in object);
    }

    return isBar(dealOwner) ? "/addbar/" + dealOwner.id : (
        isChain(dealOwner) ? "/addbar/c/" + dealOwner.id : undefined
    )
}

export function getDealOwnerDescription(dealOwner: DealParent): string|undefined {
    if (isBar(dealOwner)) {
        // bar description, otherwise chain description (all optional)
        return dealOwner.description ?? dealOwner.chain?.description ?? undefined
    } else {
        return dealOwner.description ?? undefined
    }
}

export interface IMomentDealSerializable extends Omit<IMomentDeal, "times"> {
    times: string[]
}

export function toSerializable(deal: IMomentDeal): IMomentDealSerializable {
    return {
        owner: deal.owner,
        today: deal.today,
        afterMidnight: deal.afterMidnight,
        conditions: deal.conditions,
        day: deal.day,
        tomorrow: deal.tomorrow,
        description: deal.description,
        times: [deal.times[0].toISOString(), deal.times[1].toISOString()]
    }
}

export function fromSerializable(deal: IMomentDealSerializable): IMomentDeal {
    return {
        owner: deal.owner,
        today: deal.today,
        afterMidnight: deal.afterMidnight,
        day: deal.day,
        conditions: deal.conditions,
        tomorrow: deal.tomorrow,
        description: deal.description,
        times: [moment(deal.times[0]), moment(deal.times[1])]
    }
}

export interface AfterMidnight {
    start: boolean,
    end: boolean
}